import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

import logogreen from "../images/logogreen.png";
import logoorange from "../images/logoorange.png";

import Box from "@material-ui/core/Box";

// import Brightness2Icon from "@material-ui/icons/Brightness2";
// import Brightness5Icon from "@material-ui/icons/Brightness5";
import { useAtom } from "jotai";
import { darkThemeAtom } from "../../atoms";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import Tooltip from "@material-ui/core/Tooltip";

import { Link as LinkScroll } from "react-scroll";

import FaceIcon from "@material-ui/icons/Face";
import CategoryIcon from "@material-ui/icons/Category";
//import ChatIcon from "@material-ui/icons/Chat";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";

import useScrollTrigger from "@material-ui/core/useScrollTrigger"; //for elevation scroll

import { DarkModeSwitch } from "react-toggle-dark-mode";
import { MYCOLORS } from "../../mypallette";

//elevation function for the toolbar to elevate onscroll
function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

export default function ButtonAppBar(props) {
  //access to theme
  const theme = useTheme();
  //matchSmall is true if window is sm or less(down)
  const matchSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const matchExtraSmall = useMediaQuery(theme.breakpoints.down("xs"));

  //margins for the buttons depending on if size is less than small or bigger
  let marginAmount = 1;
  matchSmall ? (marginAmount = 0.5) : (marginAmount = 1);
  const useStyles = makeStyles((theme) => ({
    flexgrow: {
      flexGrow: 1,
    },
    buttons: {
      flexGrow: 1,
      "& > *": {
        margin: theme.spacing(marginAmount),
      },
    },
  }));
  const classes = useStyles();

  //use the darkThemeAtom
  const [darkTheme, setDarkTheme] = useAtom(darkThemeAtom);
  const handleClickDarkTheme = () => {
    setDarkTheme((prev) => !prev);
  };

  //sizing for buttonIcon size
  let size = "medium";
  matchSmall ? (size = "small") : (size = "medium");

  return (
    <>
      <ElevationScroll>
        <AppBar position='fixed'>
          {matchExtraSmall ? (
            <Toolbar>
              <LinkScroll
                to='intro'
                spy={true}
                smooth={true}
                hashSpy={true}
                offset={-200}
                duration={900}
                delay={0}
                isDynamic={true}
                ignoreCancelEvents={true}
              >
                <Tooltip title='Home'>
                  <Box m={0} p={0}>
                    <IconButton>
                      <img src={darkTheme ? logoorange : logogreen} alt='logo' height='30' width='30' />
                    </IconButton>
                  </Box>
                </Tooltip>
              </LinkScroll>

              <Box align='center' className={classes.buttons}>
                <LinkScroll
                  to='about'
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  offset={-80}
                  duration={600}
                  delay={0}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                >
                  <Tooltip title='About'>
                    <IconButton variant='contained' color='secondary'>
                      <FaceIcon />
                    </IconButton>
                  </Tooltip>
                </LinkScroll>

                <LinkScroll
                  to='projects'
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  offset={-80}
                  duration={600}
                  delay={0}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                >
                  <Tooltip title='Projects'>
                    <IconButton variant='contained' color='secondary'>
                      <CategoryIcon />
                    </IconButton>
                  </Tooltip>
                </LinkScroll>

                <LinkScroll
                  to='testimonials'
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  offset={-80}
                  duration={900}
                  delay={0}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                >
                  <Tooltip title='Testimonials'>
                    <IconButton variant='contained' color='secondary'>
                      <ThumbUpIcon />
                    </IconButton>
                  </Tooltip>
                </LinkScroll>
              </Box>

              <DarkModeSwitch
                checked={!darkTheme}
                onChange={handleClickDarkTheme}
                size={30}
                style={{ margin: "0px" }}
                moonColor={MYCOLORS.lhighlight}
                sunColor={MYCOLORS.dhighlight}
              />
            </Toolbar>
          ) : (
            <Toolbar>
              <LinkScroll
                to='intro'
                spy={true}
                smooth={true}
                hashSpy={true}
                offset={-200}
                duration={900}
                delay={0}
                isDynamic={true}
                ignoreCancelEvents={true}
              >
                <Tooltip title='Home'>
                  <Box m={0} p={0}>
                    <IconButton>
                      <img src={darkTheme ? logoorange : logogreen} alt='logo' height='35' width='35' />
                    </IconButton>
                  </Box>
                </Tooltip>
              </LinkScroll>

              <Box align='center' className={classes.buttons}>
                <LinkScroll
                  to='about'
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  offset={-80}
                  duration={600}
                  delay={0}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                >
                  <Button size={size} variant='contained' color='secondary' startIcon={<FaceIcon />}>
                    About
                  </Button>
                </LinkScroll>

                <LinkScroll
                  to='projects'
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  offset={-80}
                  duration={600}
                  delay={0}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                >
                  <Button size={size} variant='contained' color='secondary' startIcon={<CategoryIcon />}>
                    Projects
                  </Button>
                </LinkScroll>

                <LinkScroll
                  to='testimonials'
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  offset={-80}
                  duration={900}
                  delay={0}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                >
                  <Button size={size} variant='contained' color='secondary' startIcon={<ThumbUpIcon />}>
                    Testimonials
                  </Button>
                </LinkScroll>
              </Box>

              <DarkModeSwitch
                checked={!darkTheme}
                onChange={handleClickDarkTheme}
                size={matchSmall ? 30 : 35}
                style={{ margin: "0px" }}
                moonColor={MYCOLORS.lhighlight}
                sunColor={MYCOLORS.dhighlight}
              />
            </Toolbar>
          )}
        </AppBar>
      </ElevationScroll>
    </>
  );
}
